import { Component } from "../Component";
import { Vector2 } from "../Math/Vector2";
import { Size2 } from "../Math/Size2";

export class ImageDrawer extends Component {

    private image: HTMLImageElement;
    rotation: number = 0;
    /**
     *
     */
    constructor(src: string, public location: Vector2, public size?: Size2) {
        super();
        this.image = new Image();
        this.image.src = src;        
    }
   
    TO_RADIANS = Math.PI/180;

    draw(ctx: CanvasRenderingContext2D): void {
        super.draw(ctx);



        if (this.size) {
            //console.log(this.rotation);
            if(this.rotation != 0) {
   
                ctx.save();
                ctx.translate(this.location.x, this.location.y); 
                //const rotation = Math.sin(this.rotationDeg * this.TO_RADIANS);
                ctx.rotate(this.rotation);
                ctx.drawImage(this.image, 0 - this.size.width / 2, 0 - this.size.height / 2, this.size.width, this.size.height);
                ctx.restore(); 
            }
            else {
                ctx.drawImage(this.image, this.location.x - this.size.width / 2, this.location.y - this.size.height / 2, this.size.width, this.size.height);
            }
            return;
        }
        ctx.drawImage(this.image, this.location.x, this.location.y);
    }

}
